import React, { useEffect, useRef, useContext } from 'react'
import { useSelector } from 'react-redux'

import PageContext from '@contexts/pageContext'
import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'
import { Box, FormField, Text } from '@campaignhub/suit-theme'

import custom from '@styles/custom.module.scss'

const defaultState = {
  showFilter: false,
}

const ZoneFilter = () => {
  const [state, setState] = useSetState(defaultState)
  const { showFilter } = state

  const { callbacks: { toggleUpdateSelectedZones }, selectedZones } = useContext(PageContext)

  const { zones } = useSelector(reduxState => reduxState.entities)

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: showFilter })

  useEffect(() => {
    if (isClickedOutside && showFilter){
      setState({ showFilter: !showFilter })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside])

  return (
    <FormField direction="column" boxProps={{ paddingBottom: 'medium' }}>
      <Box className={custom.root} ref={contentEl}>
        <select
          onMouseDown={(e) => {
            e.preventDefault()
            setState({ showFilter: !showFilter })
          }}
          value="Zones"
        >
          <option>Zones</option>
        </select>

        {showFilter && (
          <Box className={custom.popup}>
            <Box flexDirection="column" maxHeight="280px" overflowY="auto">
              {Object.values(zones).sort((a, b) => (a.name > b.name ? 1 : -1)).map(zone => (
                <Box flexDirection="row" paddingTop="small" paddingBottom="medium" alignItems="center" key={zone.id}>
                  <input
                    className={custom.checkbox}
                    onChange={e => toggleUpdateSelectedZones(e.target.checked, zone.id)}
                    type="checkbox"
                    checked={selectedZones.find(x => x.id === zone.id)}
                  />
                  <Text fontSize="small" marginLeft="medium">{zone.name}</Text>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </FormField>
  )
}

export default ZoneFilter
